import React from "react";
import { StyleSheet, View, TextInput, Alert, ActivityIndicator, Vibration } from "react-native";
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as Linking from 'expo-linking'
import * as Permissions from "expo-permissions";
import { BarCodeScanner } from "expo-barcode-scanner";
import { Button, Text } from "react-native-elements";
import Icon from "react-native-vector-icons/FontAwesome";
import { MyProvider, MyContext } from "../../rootProvider";
import HeaderImage from "../components/HeaderImage";

export default class AddParcelNumberScreen extends React.Component {
  render() {
    return <MyContext.Consumer>{context => <ParcelDataHandler context={context} navigation={this.props.navigation} />}</MyContext.Consumer>;
  }
}

class ParcelDataHandler extends React.Component {
  /*static navigationOptions = {
    title: "Neues Paket eintragen"
  };*/

  constructor(props) {
    super(props);
    this.state = {
      hasCameraPermission: null,
      scanned: false,
      doscan: false,
      type: BarCodeScanner.Constants.Type.back,
      result: null
    };
  }
  UNSAFE_componentWillMount() {}
  componentDidUpdate(prevProps, prevState) {}

  async _get_cameramermission() {
    const { status } = await Permissions.askAsync(Permissions.CAMERA);
    this.setState({ hasCameraPermission: status === "granted" });
  }

  _extractNumber = nr => {
    console.log(nr);
    if (nr.split("http://nd.dpd.de/?pknr=").length > 1) {
      return nr.split("http://nd.dpd.de/?pknr=")[1];
    } else if (nr.split("https://gls-group.eu/DE/de/paketverfolgung?match=").length > 1) {
      return nr.split("https://gls-group.eu/DE/de/paketverfolgung?match=")[1];
    } else if (nr.split("https://m.ups.com/InfoNotice/?loc=de_DE&trackingNumber=").length > 1) {
      return nr.split("https://m.ups.com/InfoNotice/?loc=de_DE&trackingNumber=")[1];
    } else {
      return "";
    }
  };
  handleBarCodeScanned = async ({ type, data }) => {
    //Vibration.vibrate(100);
    if (this.isURL(data)) {
      this.props.context.setNewParcelValue("parcelNumber", this._extractNumber(data));
    } else if (data.indexOf(" ") == -1) {
  
      this.props.context.setNewParcelValue("parcelNumber", data);
    }
    this.setState({ scanned: true });
    this.setState({ doscan: false });

    //alert(`Code erkannt! Typ: ${type} mit folgenden Daten: ${data}`);
  };
  isURL = str => {
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return pattern.test(str);
  };

  render() {
    const { hasCameraPermission, scanned, doscan } = this.state;

    /* if (hasCameraPermission === null) {
      return (
        <View style={{ flex: 1, paddingTop: 20 }}>
          <ActivityIndicator />
        </View>
      );
    }
    if (hasCameraPermission === false) {
      return <Text>Kein Zugriff auf die Kamera</Text>;
    }*/

    if (doscan === true) {
      return (
        <View
          style={{
            flex: 1,
            justifyContent: "flex-end"
          }}
        >
          <BarCodeScanner onBarCodeScanned={this.handleBarCodeScanned} style={StyleSheet.absoluteFillObject} type={this.state.type} />

          <Button title={"Abbrechen"} style={styles.abortscan} onPress={() => this.setState({ doscan: false })} buttonStyle={{ borderRadius: 0 }} />
        </View>
      );
    }

    return (
      <View style={styles.container}>
        <View style={{ padding: 5, justifyContent: "flex-start", flex: 1 }}>
          <HeaderImage image="scan" />
        </View>
        <View style={{ padding: 5, justifyContent: "center", flex: 1 }}>
          <View style={{ padding: 10, borderColor: "#ccc", borderWidth: 1 }}>
            <TextInput style={{ height: 20 }} placeholder={"Paketnummer"} onChangeText={value => this.props.context.setNewParcelValue("parcelNumber", value)} value={this.props.context.state.parcelNumber} />
          </View>

          <Button onPress={this._startqr} title={"Scannen"}  icon={<Icon name="barcode" size={20} color="white" style={{ paddingRight: 5 }} />} buttonStyle={{display:"none",  borderRadius: 0 }} />
        </View>

        <View style={{ padding: 5, justifyContent: "flex-end", flex: 1 }}>
          <Button onPress={this._nextstep} title={"Weiter"}  disabled={this.props.context.state.parcelNumber != "" ? false : true} buttonStyle={{borderRadius: 0}} />
        </View>
      </View>
    );
  }

  _openqr = () => {
    alert("open qr scanner");
  };

  _startqr = async () => {
    if (this.state.hasCameraPermission === null) {
      //
      await this._get_cameramermission();
      if (this.state.hasCameraPermission === true) {
        this.setState({ doscan: true });
      } else {
        Alert.alert(
          "Hinweis",
          "Aktiviere die Erlaubnis für den Kamerazugriff in den Einstellungen",
          [
            {
              text: "OK",
              onPress: () => {
                this.setState({ loaderIsVisible: false });
                Linking.openURL("app-settings://notification/misterpostman");
              }
            }
          ],
          { cancelable: false }
        );
      }
    } else if (this.state.hasCameraPermission === false) {
      Alert.alert(
        "Hinweis",
        "Aktiviere die Erlaubnis für den Kamerazugriff in den Einstellungen",
        [
          {
            text: "OK",
            onPress: () => {
              this.setState({ loaderIsVisible: false });
              Linking.openURL("app-settings://notification/misterpostman");
            }
          }
        ],
        { cancelable: false }
      );
      return;
    } else {
      this.setState({ doscan: true });
    }
  };

  _nextstep = () => {
    this.props.navigation.navigate("AddParcelWeight");
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    marginTop: 10,
    marginBottom: 20
  },
  abortscan: {
    backgroundColor: "#fff",
    marginBottom: 20
  }
});
